import { TranslatePipe } from '@ngx-translate/core';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { environment } from '../../../environments/environment';

type FooterLink = { label: string; href?: string; routerLink?: string };

/**
 * Footer of the signed-out app pages, built to match the footer on
 * bildigsnetz.ch (same box, texts, sizes and logo).
 */
@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, RouterLink, NgTemplateOutlet],
})
export class PublicFooterComponent {
  year = new Date().getFullYear();
  baseUrl = environment.homepageBaseUrl;

  platform: FooterLink[] = [
    { label: 'publicNav.jobs', routerLink: '/jobs' },
    { label: 'publicNav.schools', routerLink: '/schools' },
    { label: 'footer.network', routerLink: '/signup' },
    { label: 'publicNav.jobChats', href: this.baseUrl + '/stellenchats' },
    {
      label: 'footer.howItWorks',
      href: this.baseUrl + '/fur-fachkrafte',
    },
    { label: 'footer.prices', href: this.baseUrl + '/angebot' },
    { label: 'publicNav.news', href: this.baseUrl + '/news' },
  ];

  columns: { heading: string; links: FooterLink[] }[] = [
    {
      heading: 'footer.support',
      links: [
        { label: 'publicNav.about', href: this.baseUrl + '/team' },
        { label: 'publicNav.contact', href: this.baseUrl + '/kontakt' },
      ],
    },
    {
      heading: 'footer.legal',
      links: [
        { label: 'footer.imprint', href: this.baseUrl + '/impressum' },
        { label: 'footer.terms', href: this.baseUrl + '/agb' },
        { label: 'footer.privacy', href: this.baseUrl + '/datenschutz' },
      ],
    },
  ];

  social = [
    {
      icon: 'assets/brand/icon-linkedin.svg',
      alt: 'LinkedIn',
      href: 'https://www.linkedin.com/company/bildigsnetz',
    },
    {
      icon: 'assets/brand/icon-instagram.svg',
      alt: 'Instagram',
      href: 'https://www.instagram.com/bildigsnetz',
    },
  ];
}
